import "core-js/modules/es.array.push.js";
import api from "./../../../../common/api";
import common from "./../../../../common/common.js";
import { ElMessage } from 'element-plus';
import qs from 'qs';
export default {
  name: 'exceptionLogsIndex',
  components: {},
  props: {
    headerDownLoad: {
      type: Boolean,
      default: false
    },
    isMy: {
      type: Number,
      default: 0
    },
    pageNum: {
      type: Number,
      default: 12
    }
  },
  data: function () {
    return {
      orgEditShow: false,
      loading: false,
      loading_text: '加载中..',
      page: 1,
      //当前页数
      //pageNum:8,//每页显示个数
      downLoadData: [],
      //日志列表
      downLoadDataCount: 0,
      //日志记录总数
      pageCount: 0,
      //总页数
      search: this.searchInit(),
      delVisible: false,
      stateVisible: false,
      stateArr: [{
        value: 1,
        txt: '启用'
      }, {
        value: 2,
        txt: '禁用'
      }],
      state_value: '',
      state_name: '',
      down_id_selected: '',
      //选中的数据ID列表
      name_selected: [],
      //选中的数据姓名列表
      userData: [{
        username: '请选择记录人',
        id: ''
      }],
      //记录人列表
      downTypeData: [{
        txt: '请选择',
        value: 0
      }],
      emptyText: '加载中...',
      userInfo: {},
      //当前账号信息
      menuBtns: [],
      //菜单按钮列表
      isLogout: false //是否退出登录
    };
  },

  created: function () {
    if (localStorage.getItem('isLogin')) {
      var userInfo = JSON.parse(localStorage.getItem('userInfo'));
      if (userInfo) {
        this.userInfo = userInfo;
        this.menuBtns = common.menuBtns(userInfo.routes, this.$route.meta.id); //菜单按钮列表
        this.search.isMy = this.isMy ? this.isMy : 0;
        this.list();
        this.getFields();
        //console.log('onlineTestId',this.onlineTestId);
      }
    }
  },

  methods: {
    hasMenuBtns: function (param) {
      //菜单按钮是否允许显示
      if (this.menuBtns.length == 0 || this.menuBtns.indexOf(param) == -1) {
        return false;
      }
      return true;
    },
    submit: common.throttle(function () {
      this.downLoadData = [];
      this.list();
    }),
    list: function () {
      var that = this;
      this.loading = true;
      this.emptyText = this.loading_text;
      var data = this.search;
      data.page = this.page;
      data.pageNum = this.pageNum;

      // 异步更新数据
      this.$post(api.doMain() + '/download/index', qs.stringify(qs.parse(data))).then(function (res) {
        setTimeout(function () {
          that.loading = false;
        }, 200);
        if (res.rt == 1) {
          var downLoadData = res.downLoadData;
          var len = downLoadData.length;
          if (len > 0) {
            for (var i = 0; i < len; i++) {
              downLoadData[i].createdIsToday = common.isToday(downLoadData[i].created);
            }
            that.downLoadData = downLoadData;
          } else {
            that.emptyText = '无数据';
          }
          that.downLoadDataCount = res.count;
          that.pageCount = res.pageCount;
        } else {
          //that.err[`${res.id}`] = res.msg;//动态变量赋值
          ElMessage({
            type: 'warning',
            message: res.msg,
            showClose: true,
            duration: 2000
          });
          if (res.page) {
            setTimeout(function () {
              common.clearLogin();
              that.$router.push(res.page);
            }, 300);
          }
        }
      }).catch(function (error) {
        setTimeout(function () {
          that.loading = false;
        }, 200);
        common.networkError(error);
        //vant.Toast.loading({message:'网络不稳，重新加载'});
      });
    },

    delDownload: function () {
      var that = this;
      var down_id_selected = this.down_id_selected;
      if (!down_id_selected) {
        ElMessage({
          type: 'warning',
          message: '没有选中的数据',
          duration: 2000
        });
        return false;
      }
      var data = {
        down_id: down_id_selected
      };
      // 异步更新数据
      this.$post(api.doMain() + '/download/del', qs.stringify(qs.parse(data))).then(function (res) {
        that.delVisible = false;
        if (res.rt == 1) {
          setTimeout(function () {
            that.submit();
          }, 300);
          ElMessage({
            type: 'success',
            message: res.msg,
            showClose: true,
            duration: 2000
          });
        } else {
          ElMessage({
            type: 'warning',
            message: res.msg,
            showClose: true,
            duration: 2000
          });
          if (res.page) {
            setTimeout(function () {
              common.clearLogin();
              that.$router.push(res.page);
            }, 300);
          }
        }
      }).catch(function (error) {
        setTimeout(function () {
          that.loading = false;
        }, 200);
        common.networkError(error);
      });
    },
    handleSelectionChange: function (rows) {
      var down_id_selected = rows.map(item => item.down_id);
      var name_selected = rows.map(item => item.downRemark);
      this.down_id_selected = down_id_selected.toString();
      this.name_selected = name_selected;
    },
    downloadDelVisible: function (row = {}) {
      if (row.down_id) {
        this.$refs.multipleTableRef.clearSelection();
        this.$refs.multipleTableRef.toggleRowSelection(row, true); //这样就可以了
        this.down_id_selected = row.down_id;
        var name_selected = [];
        name_selected.push(row.downRemark);
        this.name_selected = name_selected;
      } else {
        var down_id_selected = this.down_id_selected;
        if (!down_id_selected || down_id_selected.length <= 0) {
          ElMessage({
            type: 'warning',
            message: '没有选中的数据',
            duration: 2000
          });
          return false;
        }
      }
      this.delVisible = true;
    },
    getFields: function () {
      var that = this;
      var data = {};
      this.loading = true;
      // 异步更新数据
      this.$post(api.doMain() + '/download/getFields', qs.stringify(qs.parse(data))).then(function (res) {
        setTimeout(function () {
          that.loading = false;
        }, 200);
        if (res.rt == 1) {
          var downTypeData = Array.isArray(res.downTypeData) ? res.downTypeData : [];
          that.downTypeData = that.downTypeData.concat(downTypeData);
        } else {
          //that.err[`${res.id}`] = res.msg;//动态变量赋值
          ElMessage({
            type: 'warning',
            message: res.msg,
            showClose: true,
            duration: 2000
          });
          if (res.page) {
            setTimeout(function () {
              common.clearLogin();
              that.$router.push(res.page);
            }, 300);
          }
        }
      }).catch(function (error) {
        setTimeout(function () {
          that.loading = false;
        }, 200);
        common.networkError(error);
        //vant.Toast.loading({message:'网络不稳，重新加载'});
      });
    },

    openUrl: function (row) {
      window.open(api.config().uploadUrl + '' + row.downUrl);
    },
    pageChange: function (page) {
      this.downLoadData = [];
      this.page = page;
      this.list();
    },
    refresh: function () {
      this.search = this.searchInit();
      this.submit();
    },
    searchClick: function () {
      this.page = 1;
      this.submit();
    },
    search_cancel: function () {
      this.search = this.searchInit();
    },
    searchInit: function () {
      var search = {
        downType: 0
        //downRemark:'',
      };

      return search;
    }
  }
};